import { render, staticRenderFns } from "./BasisDetail.vue?vue&type=template&id=02a9fc6a&scoped=true"
import script from "./BasisDetail.vue?vue&type=script&lang=js"
export * from "./BasisDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a9fc6a",
  null
  
)

export default component.exports